export const roundTo2 = (num) => {
  if (typeof num !== 'string' && typeof num !== 'number') {
    return null
  }
  return Math.round(num * 100 + Number.EPSILON) / 100
}
